'use client';

import { MutableRefObject, useEffect } from 'react';

export function useDomObserver(ref: MutableRefObject<HTMLElement | null> | undefined, callback: MutationCallback = () => { }) {

  const config = { attributes: false, childList: true, subtree: true };

  useEffect(() => {
    if (!ref || !ref.current) {
      return;
    }
    let unmount = false;
    const done: MutationCallback = (...params) => {
      // console.log('useDomObserver.MutationCallback', params);
      if (unmount) {
        return;
      }
      callback(...params);
    };
    const observer = new MutationObserver(done);
    observer.observe(ref.current, config);
    return () => {
      unmount = true;
      observer.disconnect();
    };
  }, [ref]);
}
